import { GetCurrentUserResponse } from "./../../../services/auth/auth.service.d";
import { AuthService } from "../../../services/auth";
import { parseJwt } from "../../../helpers/token";
import { UserRoles } from "../types";
import { put } from "redux-saga/effects";
import { getCurrentUserSuccess } from "../actionCreators";

export function* getCurrentUserSaga() {
    try {
        const userToken = localStorage.getItem("token");
        if (!userToken) return;
        const { role } = parseJwt(userToken);
        if (role !== UserRoles.GUEST) {
            const {
                data: { data },
            }: GetCurrentUserResponse = yield AuthService.getCurrentUser(); // CHANGE RESPONSE MODEL
            yield put(getCurrentUserSuccess(data));
        }
    } catch (error) {
        console.log("Error in getCurrentUser saga", error);
        // if (axios.isAxiosError(error))
        //     yield put(
        //         initUserFailure({ errorType: IErrorType.AXIOS, data: error.response ? error.response.data : null }),
        //     );
        // else yield put(initUserFailure({ errorType: IErrorType.NATIVE, data: error }));
        // return null;
    }
}
